import { Navigate } from 'react-router-dom';
import { getAuthToken, getUser } from '../services/auth';

export default function ProtectedRoute({ children, requiredRole, allowIncompleteProfile = false }) {
  const token = getAuthToken();
  const user = getUser();

  if (!token || !user) {
    return <Navigate to="/login" replace />;
  }

  if (!allowIncompleteProfile && user.profileComplete === false) {
    return <Navigate to="/complete-profile" replace />;
  }

  if (requiredRole) {
    const roleMappings = {
      parent: ['parent'],
      babysitter: ['babysitter'],
      admin: ['admin'],
    };

    const allowedRoles = roleMappings[requiredRole] || [requiredRole];

    if (!allowedRoles.includes(user.role)) {
      // Admins can access everything
      if (user.role === 'admin') {
        return children;
      }
      return <Navigate to="/dashboard" replace />;
    }
  }

  return children;
}

